import { useParams } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { SidebarLayout } from 'src/layout/SidebarLayout/SidebarLayout';

import { andiChatPath } from '../../constants';
import { useAndiChatEnabled } from '../../hooks/useAndiChatEnabled';

/** Andi's entry in the project's navigation, for projects whose org can use it (the andiChat entitlement). */
export const AndiNavLink = () => {
  const { projectId } = useParams();
  const enabled = useAndiChatEnabled();
  if (!enabled) return null;

  return (
    <SidebarLayout.SidebarMainLayout.ListNavLink
      to={andiChatPath(projectId)}
      label="Ask Andi"
      iconSvg={<Sparkles size={20} />}
    />
  );
};
